import { FC } from "react";

import IconProps from "./IconProps";

const DotsIcon: FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="2"
      cy="2"
      r="2"
      transform="matrix(-1 -3.64261e-09 3.36242e-09 1 18.0002 8)"
      fill="#627293"
    />
    <circle
      cx="2"
      cy="2"
      r="2"
      transform="matrix(-1 -3.64261e-09 3.36242e-09 1 12 8)"
      fill="#627293"
    />
    <circle
      cx="2"
      cy="2"
      r="2"
      transform="matrix(-1 -3.64261e-09 3.36242e-09 1 6 8)"
      fill="#627293"
    />
  </svg>
);

export default DotsIcon;
